var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-status",style:({ color: _vm.colorMap[_vm.color].color, background: _vm.colorMap[_vm.color].background })},[_c('div',{staticClass:"round",style:({ background: _vm.colorMap[_vm.color].color })}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }